import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import Header from "./Header";
import { login } from "../../services/user";

class Login extends Component {
	
	state = {
      loading: false,
    };
	
    constructor(props) {
        super(props);
        this.state = {         
            item: {},
            errors: { email: null, password: null }           
        };
    }
	
	onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };
    submitLogin = e => {
        e.preventDefault();
		this.setState({loading: true});
        login(this.state.item)
            .then(res => {
				this.setState({loading: false});
                localStorage.setItem("auth_token", res.meta.token);
                localStorage.setItem("user", JSON.stringify(res.data));
                localStorage.setItem("user_email", res.data.email);
                localStorage.setItem("user_steps", res.meta.step);
                if (res.meta.token && res.data.type === "employer") {
                    window.location = "/employer/account";
                } else if (res.meta.token && res.data.type === "writer") {
                    let path = "";

                    if (res.meta.step == 'writing-jobs') {
                        path = "/process/writingjobs";
                    } else if (res.meta.step == 'billing') {
                        path = "/process/step3";
                    } else if (res.meta.step == 'select-plan') {
                        path = "/process/select-plan";
                    } else {
                        switch (res.data.state) {
                            case "approved":
                            case "applied":
                            case "completed":
                            case "rejected":
                                path = "/account";
                                break;
                            default:
                                path = "/pw/" + res.data.url;
                                break;
                        }
                    }
                    
                    window.location = path;
                } else if (res.meta.token && res.data.type === "admin") {
                    window.location = "/admin/dashboard";
                }
            })
            .catch(error => {
				this.setState({loading: false});
                switch (error.response.status) {
                    case 422:
                        if(error.response.data.hasOwnProperty("errors"))
                        {
                            this.setState({ errors: error.response.data.errors });
                        }
                        else
                        {
                            this.setState({ errors: error.response.data.error });
                        }
                        
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show cardModalAction sign-in-model">
			    <button onClick={this.props.toggleLogin} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="title d-flex align-items-center justify-content-between">
					    <h2 className="model-title m-0" id="model-title">
                            Sign in
                        </h2>
					    {/*<p className="small-text">
					        Not a member?  
					        <Link className="ml-2" tabIndex="5" to="/process/checkout">
                                Sign up
                            </Link>
					    </p>*/}
					</div>
                    <div className="modal-body">
                    <form onSubmit={this.submitLogin} method="POST">
                            <div className="form-group">
                                <label>
                                    Email address
                                </label>

                                <input
                                    onChange={this.onChange}
                                    type="text"
                                    className={
                                        this.state.errors.email
                                            ? "is-invalid form-control  form-control-large"
                                            : " form-control  form-control-large"
                                    }
                                    name="email"
                                    autoComplete="off"
                                    tabIndex="1"
                                    placeholder="Enter your email"
                                />
                                {this.state.errors.email ? (
                                    <div className="invalid-feedback position-relative">
                                        {this.state.errors.email}
                                    </div>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <div className="row">
                                    <div className="col">
                                        <label>
                                            Password
                                        </label>
                                    </div>
                                    <div className="col-auto">
                                        <a
                                            href="javascript:void(0);"
                                            className="form-text small text-muted border-0"
                                            tabIndex="4"
											onClick={this.props.toggleResetPassword}
                                        >
                                            Forgot password?
                                        </a>
                                    </div>
                                </div>

                                <div className="input-group input-group-merge">
                                    <input
                                        tabIndex="2"
                                        onChange={this.onChange}
                                        type="password"
                                        name="password"
                                        className={
                                            this.state.errors.password
                                                ? "is-invalid form-control  form-control-large"
                                                : " form-control  form-control-large"
                                        }
                                        placeholder="Enter your password"
                                    />
                                    {this.state.errors.password ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.password}
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            <button
                                type="submit"
							    disabled={this.state.loading}
                                className="bold form-control-large btn btn-lg btn-block btn-primary mb-3 mt-5"
                                onClick={this.submitLogin}
                                tabIndex="3"
                            >
                                <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : `mr-2 fas fa-shield-alt`}></i> {this.state.loading ? `Processing...` : `Sign in`}
                            </button>
                        </form>
                    </div>                    
                </div>
            </div>
        );
    }
}

Login.contextType = AppContext;
export default Login;



// WEBPACK FOOTER //
// ./src/components/auth/Login.js